import { REVIEW_BLOCK_TYPES } from '@Pages/happyFlowPages/reviewPage/types';
import { useBoundStore } from '@Store/useBoundStore';
import { mapFieldValidationErrors } from './fieldValidation.errors';
import type { FieldValidationError, UboResponse } from '@Store/slices/customer/customer.types';

export const processFieldValidationErrors = (
  fieldValidationErrors: FieldValidationError[] | undefined | null
) => {
  if (!fieldValidationErrors?.length) {
    return;
  }

  const blockErrors = mapFieldValidationErrors(fieldValidationErrors);

  const { setReviewBlockError } = useBoundStore.getState().errorSlice;
  for (const blockType of blockErrors) {
    setReviewBlockError(blockType);
  }
};

export const processUboFieldValidationErrors = (ubos: UboResponse[]) => {
  const hasErrors = ubos.some((ubo) => ubo.fieldValidationErrors?.length);
  if (!hasErrors) {
    return;
  }

  const { setReviewBlockError } = useBoundStore.getState().errorSlice;
  setReviewBlockError(REVIEW_BLOCK_TYPES.UBOS);
};
